import React from 'react';
import { List } from 'immutable';
import PropTypes from 'prop-types';

import Button from '@Components/Button';

function TreeViewDialogFooter(props) {
  const { tags, onClickLimitTo, onClickExclude, onClickClearAllSelected } = props;

  if (!tags) {
    return null;
  }

  const disableControls = tags.count() === 0;

  return (
    <>
      <Button
        onClick={onClickClearAllSelected}
        disabled={disableControls}
        buttonConfig={{
          type: 'link',
          size: 'sm',
          label: 'Clear selected',
          className: 'tree-view-dialog-footer-close-all',
          e2eName: 'clear-selected',
        }}
        iconConfig={{ name: 'delete', size: 'tiny' }}
      />

      <div className="els-btn-group-right">
        <Button
          buttonConfig={{ type: 'primary', size: 'sm', label: 'Limit to', e2eName: 'tree-view-limit' }}
          iconConfig={{ name: 'chevron-right', size: 'tiny' }}
          disabled={disableControls}
          onClick={onClickLimitTo}
        />
        <Button
          disabled={disableControls}
          onClick={onClickExclude}
          buttonConfig={{ type: 'primary', size: 'sm', label: 'Exclude', e2eName: 'tree-view-exclude' }}
          iconConfig={{ name: 'chevron-right', size: 'tiny' }}
        />
      </div>
    </>
  );
}

TreeViewDialogFooter.propTypes = {
  tags: PropTypes.instanceOf(List).isRequired,
  onClickLimitTo: PropTypes.func.isRequired,
  onClickExclude: PropTypes.func.isRequired,
  onClickClearAllSelected: PropTypes.func.isRequired,
};

export default TreeViewDialogFooter;
